import request from '@/utils/httpClient'

// 用户访问日志
export function userAccessLogList(params?: object) {
  return request({
    url: 'userLog/accessLogPage',
    method: 'get',
    params
  })
}

// 用户操作日志
export function userOperationLogList(params?: object) {
  return request({
    url: 'userLog/operationLogPage',
    method: 'get',
    params
  })
}
